import Marquee from "react-fast-marquee";

const ITEMS = [
  "Solar powered",
  "Dusk-to-dawn sensor",
  "IP65 waterproof",
  "8–10 hour glow",
  "Warm white LED",
  "Zero wiring",
  "600 mAh battery",
];

export const EditorialMarquee = () => (
  <div className="border-y border-white/10 py-6 bg-stone-950/40" data-testid="editorial-marquee">
    <Marquee speed={30} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center gap-32 mr-32">
          <span className="text-sm uppercase tracking-[0.25em] text-stone-400">{item}</span>
          <span className="w-2 h-2 rounded-full bg-amber-400 shrink-0" />
        </span>
      ))}
    </Marquee>
  </div>
);
